/**
 * TableHeaderCell Component
 * Specialized TableCell for table headers
 */

import React from 'react';
import { TableCell } from './TableCell';
import { TableCellProps } from './TableCell';

export interface TableHeaderCellProps extends Omit<TableCellProps, 'variant'> {
  // Inherits all TableCell props but variant is always 'header'
}

export const TableHeaderCell: React.FC<TableHeaderCellProps> = (props) => {
  return <TableCell variant="header" {...props} />;
};

